import { CateringTranslations } from "./catering-pt-br";

export const CATERING_FR_FR: CateringTranslations = {
	title: "Catering",
	description:
		"Liste et configurez les articles utilisés dans les propositions de services de Catering",
};
